import { render, staticRenderFns } from "./Section10.vue?vue&type=template&id=5f58a5af&scoped=true&"
import script from "./Section10.vue?vue&type=script&lang=js&"
export * from "./Section10.vue?vue&type=script&lang=js&"
import style0 from "./Section10.vue?vue&type=style&index=0&id=5f58a5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f58a5af",
  null
  
)

export default component.exports